import { render } from "./RememberDeviceComponent.vue?vue&type=template&id=1c6e3337&scoped=true"
import script from "./RememberDeviceComponent.vue?vue&type=script&lang=js"
export * from "./RememberDeviceComponent.vue?vue&type=script&lang=js"

import "./RememberDeviceComponent.vue?vue&type=style&index=0&id=1c6e3337&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src613514666/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6e3337"]])

export default __exports__